import { OrgSdk } from 'lib-klab-sdks';

type LocationResponse = OrgSdk.LocationResponse;
type LocationCreateRequest = OrgSdk.LocationCreateRequest;
type LocationUpdateRequest = OrgSdk.LocationUpdateRequest;

type PageResponse = {
    number: number;
    size: number;
    totalElements: number;
    totalPages: number;
};

type PageEnvelope<T> = Array<{
    content: T[];
    page: PageResponse;
}>;

type DeptItem = { departmentId: number; name: string };

function deepClone<T>(v: T): T {
    return JSON.parse(JSON.stringify(v));
}

function buildHttpError(status: number, message: string) {
    return { status, message };
}

function normalizeStr(v: any): string {
    return String(v ?? '').trim();
}

function safeNumber(v: any): number {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
}

class LocationsSdkMockStore {
    private locations: LocationResponse[] = [
        {
            locationId: 1,
            name: 'Lima Headquarters',
            status: 'ACTIVE',
            departments: [{ departmentId: 1, name: 'Human Resources' }],
        } as any,
        {
            locationId: 2,
            name: 'Arequipa Hub',
            status: 'ACTIVE',
            departments: [{ departmentId: 2, name: 'Operations' }],
        } as any,
        {
            locationId: 3,
            name: 'Trujillo Site',
            status: 'ACTIVE',
            departments: [{ departmentId: 3, name: 'Finance' }],
        } as any,
        {
            locationId: 4,
            name: 'Piura Office',
            status: 'ACTIVE',
            departments: [{ departmentId: 4, name: 'IT Support' }],
        } as any,
        {
            locationId: 5,
            name: 'Cusco Branch',
            status: 'ACTIVE',
            departments: [{ departmentId: 5, name: 'People Ops' }],
        } as any,
        {
            locationId: 6,
            name: 'Chiclayo Center',
            status: 'ACTIVE',
            departments: [{ departmentId: 6, name: 'Logistics' }],
        } as any,

        {
            locationId: 7,
            name: 'Lima - San Isidro',
            status: 'ACTIVE',
            departments: [
                { departmentId: 7, name: 'Engineering' },
                { departmentId: 8, name: 'QA' },
            ],
        } as any,
        {
            locationId: 8,
            name: 'Lima - Miraflores',
            status: 'ACTIVE',
            departments: [
                { departmentId: 9, name: 'Sales' },
                { departmentId: 10, name: 'Customer Success' },
            ],
        } as any,
        {
            locationId: 9,
            name: 'Lima - Surco',
            status: 'ACTIVE',
            departments: [
                { departmentId: 11, name: 'Product' },
                { departmentId: 12, name: 'Design' },
            ],
        } as any,

        {
            locationId: 10,
            name: 'Callao Dock',
            status: 'INACTIVE',
            departments: [{ departmentId: 13, name: 'Warehouse' }],
        } as any,
        {
            locationId: 11,
            name: 'Iquitos Node',
            status: 'ACTIVE',
            departments: [{ departmentId: 14, name: 'Regional Ops' }],
        } as any,
        {
            locationId: 12,
            name: 'Huancayo Base',
            status: 'ACTIVE',
            departments: [{ departmentId: 15, name: 'Field Services' }],
        } as any,
        {
            locationId: 13,
            name: 'Tacna Office',
            status: 'ACTIVE',
            departments: [{ departmentId: 16, name: 'Compliance' }],
        } as any,
        {
            locationId: 14,
            name: 'Puno Branch',
            status: 'ACTIVE',
            departments: [{ departmentId: 17, name: 'Security' }],
        } as any,
        {
            locationId: 15,
            name: 'Moquegua Site',
            status: 'INACTIVE',
            departments: [{ departmentId: 18, name: 'Maintenance' }],
        } as any,
        {
            locationId: 16,
            name: 'Juliaca Hub',
            status: 'ACTIVE',
            departments: [{ departmentId: 19, name: 'Procurement' }],
        } as any,
        {
            locationId: 17,
            name: 'Chimbote Center',
            status: 'ACTIVE',
            departments: [{ departmentId: 20, name: 'Fleet' }],
        } as any,
        {
            locationId: 18,
            name: 'Barranco Annex',
            status: 'ACTIVE',
            departments: [{ departmentId: 21, name: 'Marketing' }],
        } as any,
        {
            locationId: 19,
            name: 'San Miguel Office',
            status: 'ACTIVE',
            departments: [{ departmentId: 22, name: 'Legal' }],
        } as any,
        {
            locationId: 20,
            name: 'La Molina Office',
            status: 'ACTIVE',
            departments: [{ departmentId: 23, name: 'Data' }],
        } as any,
        {
            locationId: 21,
            name: 'Magdalena Hub',
            status: 'ACTIVE',
            departments: [{ departmentId: 24, name: 'Analytics' }],
        } as any,

        {
            locationId: 22,
            name: 'Lima Headquarters_created_by_postman',
            status: 'ACTIVE',
            departments: [
                { departmentId: 33, name: 'Human Resourcesv1postman' },
                { departmentId: 34, name: 'Human Resourcesv12postman' },
            ],
        } as any,

        {
            locationId: 23,
            name: 'SJL Branch',
            status: 'ACTIVE',
            departments: [{ departmentId: 25, name: 'Support' }],
        } as any,
        {
            locationId: 24,
            name: 'Comas Branch',
            status: 'ACTIVE',
            departments: [{ departmentId: 26, name: 'Training' }],
        } as any,
        {
            locationId: 25,
            name: 'Los Olivos Hub',
            status: 'ACTIVE',
            departments: [
                { departmentId: 27, name: 'Engineering' },
                { departmentId: 28, name: 'QA' },
            ],
        } as any,
        {
            locationId: 26,
            name: 'San Juan de Miraflores',
            status: 'ACTIVE',
            departments: [{ departmentId: 29, name: 'Ops' }],
        } as any,
        {
            locationId: 27,
            name: 'Villa El Salvador',
            status: 'ACTIVE',
            departments: [{ departmentId: 30, name: 'Dispatch' }],
        } as any,
        {
            locationId: 28,
            name: 'Rimac Office',
            status: 'INACTIVE',
            departments: [{ departmentId: 31, name: 'Warehouse' }],
        } as any,
        {
            locationId: 29,
            name: 'San Borja Office',
            status: 'ACTIVE',
            departments: [{ departmentId: 32, name: 'Administration' }],
        } as any,

        {
            locationId: 45,
            name: 'new location 2',
            status: 'ACTIVE',
            departments: [{ departmentId: 73, name: 'new department 2' }],
        } as any,

        {
            locationId: 46,
            name: 'Test Location - Dashboard',
            status: 'ACTIVE',
            departments: [{ departmentId: 74, name: 'Productivity' }],
        } as any,
    ];

    private nextId = 100;

    getAllLocations(page = 0, size = 10): PageEnvelope<LocationResponse> {
        const p = Math.max(0, safeNumber(page));
        const s = Math.max(1, safeNumber(size));

        const sorted = [...this.locations].sort((a, b) => (a.locationId ?? 0) - (b.locationId ?? 0));

        const totalElements = sorted.length;
        const totalPages = Math.max(1, Math.ceil(totalElements / s));

        const start = p * s;
        const end = start + s;

        const content = sorted.slice(start, end);

        return [
            {
                content: deepClone(content),
                page: {
                    number: p,
                    size: s,
                    totalElements,
                    totalPages,
                },
            },
        ];
    }

    getLocationById(locationId: number): LocationResponse {
        const id = safeNumber(locationId);
        const found = this.locations.find((l) => safeNumber(l.locationId) === id);

        if (!found) throw buildHttpError(404, 'Location no encontrada');
        return deepClone(found);
    }

    createLocation(payload: LocationCreateRequest): LocationResponse {
        const name = normalizeStr((payload as any)?.name);
        const departments = ((payload as any)?.departments ?? []) as (string | DeptItem)[];

        if (!name) throw buildHttpError(400, 'Nombre es requerido');

        const depMapped: DeptItem[] = (departments ?? [])
            .map((d) => {
                if (typeof d === 'string') {
                    return { departmentId: 0, name: normalizeStr(d) };
                }
                return {
                    departmentId: safeNumber((d as any)?.departmentId),
                    name: normalizeStr((d as any)?.name),
                };
            })
            .filter((d) => !!d.name);

        const created: LocationResponse = {
            locationId: this.nextId++,
            name,
            status: 'ACTIVE',
            departments: depMapped,
        } as any;

        this.locations.push(created);

        return deepClone(created);
    }

    updateLocation(locationId: number, payload: LocationUpdateRequest): LocationResponse {
        const id = safeNumber(locationId);
        const idx = this.locations.findIndex((l) => safeNumber(l.locationId) === id);

        if (idx < 0) throw buildHttpError(404, 'Location no encontrada');

        const current = this.locations[idx];

        const nextName = normalizeStr((payload as any)?.name) || normalizeStr((current as any)?.name);
        const items = (((payload as any)?.departments ?? []) as any[]);

        const nextDepartments = this.applyDeptActions(current.departments as any, items);

        const updated: LocationResponse = {
            ...current,
            name: nextName,
            departments: nextDepartments,
        } as any;

        this.locations[idx] = updated;

        return deepClone(updated);
    }

    deleteLocation(locationId: number): void {
        const id = safeNumber(locationId);
        const idx = this.locations.findIndex((l) => safeNumber(l.locationId) === id);

        if (idx < 0) throw buildHttpError(404, 'Location no encontrada');

        this.locations.splice(idx, 1);
    }

    private applyDeptActions(
        currentDepts: Array<{ departmentId: number; name: string }> = [],
        payloadItems: any[] = [],
    ): Array<{ departmentId: number; name: string }> {
        let next = [...(currentDepts ?? [])].map((d) => ({
            departmentId: safeNumber((d as any)?.departmentId),
            name: normalizeStr((d as any)?.name),
        })).filter(d => d.departmentId > 0 && !!d.name);

        for (const it of payloadItems) {
            const depId = safeNumber(it?.departmentId);
            const depName = normalizeStr(it?.name);
            const action = it?.action;

            if (action === OrgSdk.DepartmentUpdateItem.ActionEnum.Delete) {
                if (depId > 0) next = next.filter((d) => d.departmentId !== depId);
                continue;
            }

            if (action === OrgSdk.DepartmentUpdateItem.ActionEnum.Add) {
                if (depId > 0 && depName) {
                    const exists = next.some((d) => d.departmentId === depId);
                    if (!exists) next.push({ departmentId: depId, name: depName });
                }
                continue;
            }

            if (depId > 0 && depName) {
                const idx = next.findIndex((d) => d.departmentId === depId);
                if (idx >= 0) next[idx] = { departmentId: depId, name: depName };
                else next.push({ departmentId: depId, name: depName });
            }
        }

        next.sort((a, b) => a.departmentId - b.departmentId);
        return next;
    }
}

const store = new LocationsSdkMockStore();

export const locationsSdkMock = {
    getAllLocations: (page: number, size: number) => store.getAllLocations(page, size),
    getLocationById: (locationId: number) => store.getLocationById(locationId),
    createLocation: (payload: LocationCreateRequest) => store.createLocation(payload),
    updateLocation: (locationId: number, payload: LocationUpdateRequest) => store.updateLocation(locationId, payload),
    deleteLocation: (locationId: number) => store.deleteLocation(locationId),
};